import React, { useState, useEffect } from 'react';
// import { IProps } from '../component';
import SignaturePad from 'react-signature-canvas'
import styles from './sigpad.module.sass'
import { Modal, Icon, Button } from 'antd'
export const SignaturePadModal = () => {
    let sigPad: any = {}
    const [visible, setVisible] = useState(false)
    const clear = () => {
        sigPad.clear()
    }

    useEffect(() => {
        window.addEventListener("message", signaturePadListener);
    }, [])

    const signaturePadListener = (e: any) => {
        if (e.data.action === "signaturePadOpen") {
            setVisible(true)
        }
    }
    return (
        <React.Fragment>
            <Modal
                width={576}
                maskClosable={false}
                className={`Bpmn_Create_Modal card-container`}
                title={<div data-test-id="signature_pad" className="modal-header-title" >SIGNATURE PAD</div>}
                onCancel={() => {
                    setVisible(false);
                }}
                closeIcon={<Icon data-test-id="signature_pad_close_icon" style={{ color: "white" }} type="close" />}
                destroyOnClose={true}
                footer={[
                    <div key={"footer-1"} >

                        <Button
                            data-test-id="clear"
                            style={{
                                color: "#1D7AFF", width: "135px",
                                height: "40px"
                            }} onClick={() => {
                                clear()
                            }}>
                            Clear
                        </Button>
                        <Button
                            data-test-id="save"
                            style={{
                                width: "135px",
                                height: "40px",
                                backgroundColor: "#F1722E"
                            }}
                            //type="primary"
                            className="modal-create-Button"
                            onClick={() => {
                                setVisible(false)
                            }}
                        >
                            Save
                        </Button>
                    </div>
                ]}
                visible={visible}
            >            <div className='override-common' >
                    <div data-test-id="container" className={styles.container} onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                    }}>
                        <div className={styles.sigContainer}>
                            <SignaturePad
                                data-test-id="signature_pad"
                                canvasProps={{ className: styles.sigPad }}
                                ref={(ref) => { sigPad = ref }} />
                        </div>
                    </div>

                </div>
            </Modal>

        </React.Fragment>
    )
}